import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { PopupContext } from "../../index";
import { showDangerToast, showSuccessToast, showWarningToast } from "../../validation/ToastContainer";
import { POPUP_TYPES, getConfirmPopup, getDeletePopup } from "../../view/popup/PopupContainer";
import * as ruleService from "../ruleService";
import { useMsbTableHelper } from "./useMsbTableHelper";

function RuleActionsDropdown({ selectedRules = [] }) {

    const history = useHistory();
    //const [selection, setSelection] = useState([]);
    const { setPopup } = useContext(PopupContext);
    const helper = useMsbTableHelper();
    const [msbId] = useState();
    const [disabledCopyMenu, setDisabledCopyMenu] = useState(true);
    const [disabledReMoveMenu, setDisabledReMoveMenu] = useState(true);


    // useEffect(() => {
    //     if (selectedRules.length === 0) {
    //         setDisabledCopyMenu(true);
    //         setDisabledReMoveMenu(true);
    //     }
    //     else {
    //         setDisabledCopyMenu(false);
    //         setDisabledReMoveMenu(false);
    //         for (const rule of selectedRules) {
    //             if (rule.baseRule === true) {
    //                 setDisabledReMoveMenu(true)
    //             }
    //         }
    //     }        
    // }, [selectedRules]);

    useEffect(() => {
        //setSelection(selectedRules);
        if (selectedRules.length === 0) {
            setDisabledCopyMenu(true);
            setDisabledReMoveMenu(true);
        }
        else {
            setDisabledCopyMenu(false);
            setDisabledReMoveMenu(false);
            for (const rule of selectedRules) {
                if (rule.baseRule === true) {
                    setDisabledReMoveMenu(true)
                }
            }
        }
    }, [selectedRules]);

    const onActionChange = (value) => {
        switch (value) {
            case '1': {
                history.push('/add-rules');
                break;
            }
            case '2': {
                onCopyRules();
                break;
            }
            case '3': {
                onMoveRules();
                break;
            }
            case '4': {
                RemoveRules();
                break;
            }
            case '5': {
                EnableRemediation();
                break;
            }
            case '6': {
                history.push('/parameters');
                break;
            }
            default:
                return;
        }
    }

    const EnableRemediation = () => {
        const onConfirm = async () => {
            if (!selectedRules || selectedRules.length === 0) {
                return showWarningToast('No selected rules to enable system remediation', 'Enable System Remediation', 'aborted');
            }
            //const ruleIdList = selectedRules.map(obj => obj.id);
            ruleService.enableSystemRemediation(selectedRules)
                .then((success) => {
                    if (success) {
                        //setSelection([]);
                        //history.go(0)
                        helper.hardReload();
                        //config.selected= [];
                        //selectedRules = [];
                        showSuccessToast('System Remediation has enabled on selected rules', 'Enable System Remediation', 'success');
                    } else {
                        showDangerToast('Something went wrong', 'Enable System Remediation');
                    }
                });
        }
        setPopup(
            getConfirmPopup('Are you sure?',
                'Enable System Remediation',
                () => onConfirm()
            )
        );
    }

    const onCopyRules = () => setPopup(
        {
            type: POPUP_TYPES.COPY_TO_MSB,
            title: "Copy to Selected Msb",
            msbId: msbId,
            confirm: confirmCopyRules
        }
    );

    const confirmCopyRules = async (msbId) => {
        if (!selectedRules || selectedRules.length === 0) {
            showWarningToast('No selected rules to copy', 'Copy Rules', 'aborted');
            return;
        }

        CopyRulesList(selectedRules, msbId)
            .then(() => {
                helper?.hardReload?.();
            });
    };

    const CopyRulesList = (rules, selectedMsbId) => {
        const onConfirm = async () => {
            if (!rules || rules.length === 0) {
                return showWarningToast('No selected rules to copy', 'Copy Rules', 'aborted');
            }
            const ruleIdList = rules.map(obj => obj.id);
            ruleService.copyRuleList(ruleIdList, selectedMsbId)
                .then((success) => {
                    if (success) {
                        helper.hardReloadSelection();
                        showSuccessToast('Selected rules were copied', 'Copy Rules', 'success');
                    } else {
                        showDangerToast('Something went wrong', 'Copy Rules');
                    }
                });
        }
        setPopup(
            getConfirmPopup('Are you sure?',
                'Copy Rules',
                () => onConfirm()
            )
        );
    };

    const onMoveRules = () => setPopup(
        {
            type: POPUP_TYPES.COPY_TO_MSB,
            title: "Move to Selected Msb",
            msbId: msbId,
            confirm: confirmMoveRules
        });

    const confirmMoveRules = async (msbId) => {
        if (!selectedRules || selectedRules.length === 0) {
            showWarningToast('No selected rules to move', 'Move Rules', 'aborted');
            return;
        }

        MoveRulesList(selectedRules, msbId)
            .then(() => {
                helper?.hardReload?.();
            });
    };

    const MoveRulesList = (rules, selectedMsbId) => {
        const onConfirm = async () => {
            if (!rules || rules.length === 0) {
                return showWarningToast('No selected rules to move', 'Move Rules', 'aborted');
            }
            const ruleIdList = rules.map(obj => obj.id);
            ruleService.moveRuleList(ruleIdList, selectedMsbId)
                .then((success) => {
                    if (success) {
                        helper.hardReload();
                        showSuccessToast('Selected rules were moved', 'Move Rules', 'success');
                    } else {
                        showDangerToast('Something went wrong', 'Move Rules');
                    }
                });
        }
        setPopup(
            getConfirmPopup('Are you sure?',
                'Move Rules',
                () => onConfirm()
            )
        );
    };

    const RemoveRules = () => {
        const onConfirm = async () => {
            if (!selectedRules || selectedRules.length === 0) {
                return showWarningToast('No selected rules to remove', 'Remove Rules', 'aborted');
            }
            const ruleIdList = selectedRules.map(obj => obj.id);
            ruleService.removeList(ruleIdList)
                .then((success) => {
                    if (success) {
                        helper.hardReload();
                        showSuccessToast('Selected rules were removed', 'Remove Rules', 'success');
                    } else {
                        showDangerToast('Something went wrong', 'Remove Rules');
                    }
                });
        }
        setPopup(
            getDeletePopup('Are you sure you want to remove the selected rules?',
                'Remove Rules',
                () => onConfirm(),
                undefined,
                'Remove Rules'
            )
        );
    }


    // Build options array matching existing native <select> options and disabled states
    const actionOptions = [
        { value: '1', label: 'Add Rule' },
        { value: '2', label: 'Copy Rules', isDisabled: disabledCopyMenu },
        { value: '3', label: 'Move Rules', isDisabled: disabledReMoveMenu },
        { value: '4', label: 'Remove Rules', isDisabled: disabledReMoveMenu },
        { value: '5', label: 'Enable System Remediation', isDisabled: disabledCopyMenu },
        { value: '6', label: 'Manage Parameters' },
    ];

    return (
        <Select
            id="ruleactions"
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={null}
            onChange={(selectedOption) => {
                if (selectedOption) {
                    onActionChange(selectedOption.value);
                }
            }}
            options={actionOptions}
            isOptionDisabled={(option) => option.isDisabled}
            isSearchable={false}
            placeholder="Choose"
            noOptionsMessage={() => "No actions available"}
        />
    )
}


export default RuleActionsDropdown;
